import { createTheme } from '@mui/material/styles';

const getTheme = (mode = 'light') => {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: isDark ? '#4d9fff' : '#0066cc',
      },
      secondary: {
        main: isDark ? '#ff4d9f' : '#cc0066',
      },
      success: {
        main: isDark ? '#4caf50' : '#28a745',
      },
      warning: {
        main: isDark ? '#ffb300' : '#ffc107',
      },
      error: {
        main: isDark ? '#f44336' : '#dc3545',
      },
      info: {
        main: isDark ? '#29b6f6' : '#17a2b8',
      },
      background: {
        default: isDark ? '#121212' : '#ffffff',
        paper: isDark ? '#1e1e1e' : '#f5f5f5',
      },
      text: {
        primary: isDark ? '#e0e0e0' : '#212121',
        secondary: isDark ? '#b0b0b0' : '#757575',
        disabled: isDark ? '#808080' : '#9e9e9e',
      },
      divider: isDark ? '#404040' : '#e0e0e0',
    },
    typography: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      fontSize: 14,
      h1: { fontSize: '2.5rem', fontWeight: 600 },
      h2: { fontSize: '2rem', fontWeight: 600 },
      h3: { fontSize: '1.75rem', fontWeight: 600 },
      h4: { fontSize: '1.5rem', fontWeight: 600 },
      h5: { fontSize: '1.25rem', fontWeight: 600 },
      h6: { fontSize: '1.1rem', fontWeight: 600 },
      body1: { fontSize: '1rem', lineHeight: 1.5 },
      body2: { fontSize: '0.875rem', lineHeight: 1.43 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: isDark ? '#121212' : '#ffffff',
            color: isDark ? '#e0e0e0' : '#212121',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#1e1e1e' : '#ffffff',
            borderColor: isDark ? '#404040' : '#e0e0e0',
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#1e1e1e' : '#ffffff',
          },
        },
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#2d2d2d' : '#f5f5f5',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderColor: isDark ? '#404040' : '#e0e0e0',
            fontSize: '1rem',
            padding: '14px 12px',
          },
          head: {
            backgroundColor: isDark ? '#2d2d2d' : '#e0e0e0',
            fontWeight: 600,
            fontSize: '1.1rem',
            padding: '16px 12px',
            color: isDark ? '#e0e0e0' : '#212121',
          },
          body: {
            fontSize: '1rem',
            color: isDark ? '#e0e0e0' : '#212121',
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            '&:hover': {
              backgroundColor: isDark ? '#2d2d2d !important' : '#f5f5f5 !important',
            },
          },
        },
      },
    },
  });
};

export default getTheme;
